import React from 'react';
import {observer} from 'mobx-react';
import ReactDOM from "react-dom";
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {TooltipArrowBox} from "./boxes/tooltip-arrow/tooltip-arrow.box";
import {TooltipCloseButtonBox} from "./boxes/tooltip-close-button.box";
import {TooltipContainerBox} from "./boxes/tooltip-container/tooltip-container.box";
import {CyClass} from "../../../common/cy-classes";
import { TooltipGlowBox } from './boxes/tooltip-glow/tooltip-glow.box';
import { TooltipContentBox } from './boxes/tooltip-content.box';
import {ITooltipViewModel} from "../../services/tooltip/tooltip-base/tooltip-view-model.interface";
import {ITooltipsProvider} from "../../services/tooltip/tooltips-provider.interface";
import {ThemeProvider} from 'styled-components';

interface ToolTipComponentProps {
    toolTip: ITooltipViewModel;
}

export const ToolTipComponent = observer(class ToolTipComponent extends OrbitComponent<ToolTipComponentProps> {

    private _captureElementRef = (element: HTMLDivElement) => {
        if(element) {
            this.props.toolTip.onToolTipRendered(element);
        }
    }

    render() {
        const currentTooltip = this.props.toolTip;
        if(!currentTooltip.shouldDisplay()) {
            return null;
        }

        const content = currentTooltip?.render();
        const hasGlow = Boolean(currentTooltip?.hasGlow);

        return ReactDOM.createPortal(
            <ThemeProvider theme={this.services.theme.popupsTheme}>
                <TooltipContainerBox
                    className={CyClass('cy-tooltip-container')}
                    ref={this._captureElementRef}
                    zIndex={currentTooltip?.zIndex || 0}
                    active={Boolean(currentTooltip)}
                    animated={Boolean(currentTooltip?.animated)}
                    hasGlow={hasGlow}
                    {...currentTooltip?.styling}>

                    {hasGlow && <TooltipGlowBox/>}

                    {currentTooltip?.shouldShowCloseButton && <TooltipCloseButtonBox onClick={() => currentTooltip.closeTooltip()} invertColors={currentTooltip.invertCloseButtonColors}/>}

                    <TooltipContentBox>
                        {content}
                    </TooltipContentBox>

                    <TooltipArrowBox
                        id="tool-tip-container-arrow"
                        data-popper-arrow=""
                        {...currentTooltip?.styling}
                    />

                    {hasGlow && <TooltipGlowBox bottom/>}

                </TooltipContainerBox>
            </ThemeProvider>
            , this.services.dom.body);
    }
});

interface ToolTipContainerComponentProps {
    toolTipsProvider: () => ITooltipsProvider;
}

@observer
export class ToolTipContainerComponent extends OrbitComponent<ToolTipContainerComponentProps> {
    
    render() {
        const toolTips = this.props.toolTipsProvider().toolTips;
        return (
            <>
                {toolTips.map(t => <ToolTipComponent key={t.id} toolTip={t}/>)}
            </>
        )
    }
}